import { isArray } from "lodash";
import { Logger } from "./logger";

export const postMessageToRef = (ref: any, msg: any) => {
  Logger.log("Posting message: ", msg);

  const message = JSON.stringify(msg);

  if (isArray(ref)) {
    ref.forEach((r) => {
      r.current?.contentWindow.postMessage(message, "*");
    });
  } else {
    ref.current?.contentWindow.postMessage(message, "*");
  }
};

export const postMessageToParent = (msg: any) => {
  const message = JSON.stringify(msg);
  window.parent.postMessage(message, "*");
};
